import { findChildren } from "./../../tiptap/index.js";
const findNodeById = (tr, id) => {
  return findChildren(tr.doc, (node) => node.attrs.id === id);
};
export {
  findNodeById
};
//# sourceMappingURL=find-node-by-id.js.map
